import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import { getImageUrl } from 'lib/image/imageUtils'
import Clickable from 'components/Common/Clickable'

const BannerWrapper = styled(Group)`
  background-image: url(${getImageUrl('tour-catalog-banner-mobile-background')});
  background-size: 100%;
  padding: ${rem(20)};

  ${mediaQueryUp.tablet} {
    background-image: url(${getImageUrl('tour-catalog-banner-background')});
    background-position: center;
    padding: ${rem(24)};
  }
`

function TourCatalogueBanner() {
  return <Clickable href="/tours/tours-catalogue">
    <BannerWrapper
      direction="vertical"
      horizontalAlign="start"
      tabletDirection="horizontal"
      tabletHorizontalAlign="space-between"
      tabletVerticalAlign="center"
      gap={32}
    >
      <VerticalSpacer gap={0}>
        <HeadingTextBlock variant="heading1" colour="neutral-eight"><i>Tours Catalogue</i></HeadingTextBlock>
        <BodyText variant="medium" colour="neutral-eight">Go beyond the ordinary and discover the difference.</BodyText>
      </VerticalSpacer>
      <TextButton kind="primary" variant="ghost" size="small" to="/tours/tours-catalogue">View now</TextButton>
    </BannerWrapper>
  </Clickable>
}

export default TourCatalogueBanner
